import { EmbedChat } from './EmbedChat';
import { EmbedWindow } from './EmbedWindow';
import { FloatingWindow } from './FloatingWindow';

export const variants = {
  floating: FloatingWindow,
  'embed-bubble': EmbedWindow,
  'embed-chat': EmbedChat
};
